module.exports = __webpack_public_path__ + "static/img/c-ddl.4692ede1.png";